var GraphQlRequest = /** @class */ (function () {
    function GraphQlRequest(query, mutation, variables) {
        this.query = query;
        this.variables = variables;
        if (mutation) {
            this.query = "mutation {" + mutation + "}";
        }
    }
    return GraphQlRequest;
}());
export default GraphQlRequest;
//# sourceMappingURL=GraphQlRequest.js.map